import { render, staticRenderFns } from "./StaticPluginLoader.vue?vue&type=template&id=9eb529a0&scoped=true"
import script from "./StaticPluginLoader.vue?vue&type=script&lang=js"
export * from "./StaticPluginLoader.vue?vue&type=script&lang=js"
import style0 from "./StaticPluginLoader.vue?vue&type=style&index=0&id=9eb529a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb529a0",
  null
  
)

export default component.exports